/* RATE HISTORY VOID (owner 26-Oct-2026) — a voided rate-history row on the rate card's history (struck through, "Void - <reason>"),
   the unrated reason of an entry whose rate on its date was voided, and the Founder Maintenance firm / parameter prompts. EN + AR.
   Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_RHV = {
  en: {
    rhv: {
      voidLabel: "Void - {reason}",
      pickFirm: "Pick a firm (required)",
      firmRequired: "One firm only",
      paramPlaceholder: "grade | DD-MMM-YYYY or row id | reason",
    },
    dsBilling: { reason: { rate_voided: "test rate removed" } },
  },
  ar: {
    rhv: {
      voidLabel: "ملغى - {reason}",
      pickFirm: "اختر شركة (مطلوب)",
      firmRequired: "شركة واحدة فقط",
      paramPlaceholder: "الدرجة | DD-MMM-YYYY أو معرّف الصف | السبب",
    },
    dsBilling: { reason: { rate_voided: "أُزيل سعر الاختبار" } },
  },
};

export default I18N_RHV;
